/**
 * Los tres estados del switch de alcance del Header (Global).
 *
 * Son COMPLEMENTARIOS a propósito: `activas` + `sinUso` = `todas`, siempre.
 * Por eso los tres botones suman las 157 tiendas del catálogo y el usuario
 * puede comprobar de un vistazo que no se está perdiendo ninguna — que es
 * exactamente el defecto que motivó esto (el 24-ago faltaba una tienda entera,
 * ADUANA, y con ella $108.698 del total).
 *
 * La definición de "activa" es la que ya usaba el switch: **al menos una
 * solicitud surtida por el bodeguero en el periodo** (`atendidas > 0`). No es
 * "tuvo consultas": una tienda puede consultar y que bodega no le surta nada.
 *
 * ⚠️ DECISIÓN DEL 2026-08-24, tomada con el usuario sabiendo el matiz: "Sin uso"
 * es el complemento EXACTO de "Activas", así que incluye tanto a las tiendas que
 * no han tocado la herramienta (4: ADUANA, TAF 242, TAF 226, TAF 27) como a las
 * que la usan y no reciben respuesta de bodega (3, entre ellas VAZ 200
 * CUPATITZIO con 211 consultas y 0 atendidas). Se eligió la simetría —que los
 * botones siempre sumen 157— sobre la precisión del nombre. Si algún día se
 * quiere distinguir, el caso "consulta y no le surten" merece su propio botón:
 * es un problema de bodega, no de adopción.
 */
export type ModoTiendas = 'activas' | 'sinUso' | 'todas';

/** El modo por defecto de la pantalla, el mismo que tenía el switch booleano. */
export const MODO_POR_DEFECTO: ModoTiendas = 'activas';

/**
 * ¿Una fila con estas `atendidas` entra en el modo elegido?
 *
 * Único sitio donde vive la regla: `aggregateGlobal`, `buildSucursalTableRows` y
 * el cascadeo de filtros la comparten para que las tres vistas no puedan
 * discrepar.
 */
export function entraEnModo(atendidas: number, modo: ModoTiendas): boolean {
  if (modo === 'todas') return true;
  return modo === 'activas' ? atendidas > 0 : atendidas <= 0;
}
